<!--
  付款码
  lovi 2020-06-17
-->
<template>
  <div class="w100">
    <van-nav-bar
      class="head-blue"
      :title="$t('home.paymentCode')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper">
      <div class="info-box" v-if="payPsd">
        <div id="qrCode" ref="qrCode"></div>
        <p class="text-blue" @click="getQrcode(1)">
          <i class="refresh" :class="{ rotate360: refreshFlag }"></i>
          <span>{{ $t("common.refresh") }}</span>
        </p>
      </div>
    </div>
    <enter-payPsd
      :payPsdFlag.sync="payPsdFlag"
      :type="1"
      @getPayPsd="getPayPsd"
    />
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import EnterPayPsd from "@/components/enterPayPsd";
export default {
  name: "paymentCode",
  meta: {
    service: false // 客服
  },
  components: {
    EnterPayPsd
  },
  data() {
    return {
      // 支付密码
      payPsdFlag: false,
      payPsd: "",
      refreshFlag: false
    };
  },
  created() {},
  mounted() {
    this.getQrcode();
    // this.createQrcode("qrCode");
  },
  computed: {},
  methods: {
    getPayPsd(data) {
      console.log("getPayPsd", data);
      this.payPsd = data;
      this.getQrcode();
    },
    getQrcode(flag) {
      let vm = this;
      let params = {};
      params.type = 1;
      params.pay_password = vm.payPsd;
      if (vm.payPsd == "") {
        vm.payPsdFlag = true;
        return;
      }
      let loading = true;
      if (flag) {
        this.refreshFlag = true;
        loading = false;
      }
      vm.$post("/app/recharge/qrCode", params, {
        loading: loading,
        alert: true
      }).then(res => {
        this.refreshFlag = false;
        console.log("qrCode", res);
        if (res.code == 0) {
          this.$refs.qrCode.innerHTML = "";
           vm.createQrcode(res.data.QRCode);
          //vm.createQrcode("hellohellohello1");
          // this.qrCodeDecrypt(res);
        } else {
          vm.$toast(res.msg);
        }
      });
    },
    qrCodeDecrypt(data) {
      this.$post(
        "/app/recharge/QrCodeDecrypt",
        { qrcode: data.QRCode },
        {
          loading: true
        }
      ).then(res => {
        console.log("QrCodeDecrypt", res);
      });
    },
    createQrcode(str) {
      // 生成二维码
      new QRCode(this.$refs.qrCode, {
        width: 200,
        height: 200,
        text: str // 内容
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.scroll-wrapper {
  background: #1e39a1;
}
.info-box {
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 320px;
  padding: 15px;
  background: #fff;
  border-radius: 8px;
  #barCode {
    width: 100%;
  }
  #qrCode {
    margin: 15px auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  p {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    .refresh {
      margin-right: 5px;
      width: 16px;
      height: 16px;
      background-image: url("@{images}public/icon_refresh@2x.png");
      background-size: 100%;
    }
  }
}
</style>
